import { getCurrentAuth } from '../http-server';
import { jwtDecode } from 'jwt-decode';
const useCommonDetails = () => {
  const auth: any = getCurrentAuth();
  const decodedToken: any = auth ? jwtDecode(auth.Token) : null;
  return decodedToken;
};
export default useCommonDetails;
